<template>
  <div class="box signup_bg">
    <div class="wrap" style="width: 1100px;">
      <div class="train_title">资讯新闻</div>
      <div class="tarin_list">
        <h5 class="none_ts" v-if="!lists" style="text-align: center;">
          <img src="@/assets/images/none_data.jpg" alt="">
        </h5>
        <dl v-for="item in lists" v-bind:key="item.id">
          <dt>
            <img src="@/assets/images/zy_default.png" v-if="!item.cover || item.cover == ''" />
            <img :src="item.cover" v-if="item.cover && item.cover !== ''">
          </dt>
          <dd>
            <h4 @click="to('news', item.id)" style="cursor: pointer;">
              <a>{{item.title}}</a>
              <p style="font-size: 12px; color: #666;">{{item.updateDate}}</p>
            </h4>
            <p v-html="item.content"></p>
          </dd>
        </dl>
        <div class="onsite_list_bottom mtf30">
          <div v-if="cntData > 0">共<b>{{cntData}}</b>条</div>
          <div v-if="cntData > 0">
            <paginate :click-handler="clickCallback" :page-count=pages
                      :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                      :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                      :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                      :first-last-button=$global.paginationOptions.first_last_button
                      :active-class=$global.paginationOptions.active_class
                      :disabled-class=$global.paginationOptions.disabled_class
                      :first-button-text=$global.paginationOptions.first_button_text
                      :last-button-text=$global.paginationOptions.last_button_text
                      :prev-text=$global.paginationOptions.prev_text
                      :next-text=$global.paginationOptions.next_text>
            </paginate>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import config from '@/config'
  import api from '@/api'
  import Paginate from 'vuejs-paginate'
    export default {
      components: { Paginate },
      data () {
        return {
          filters: {
            pageNo: 1,
            pageSize: 12,
            title: '',
            type: '01',
            state: '1',
            audit: '1'
          },
          lists: [],
          pages: 0,
          cntData: '',
          pool: {
            information_type: {}
          }
        }
      },
      created () {
        this.search(this.filters)
      },
      methods: {
        clickCallback (pageNum) {
          this.filters.pageNo = pageNum
          this.search(this.filters)
        },
        to (path, id) {
          this.$router.push({
            path: path + '/' + id
          })
        },
        search (filters) {
          api.post(config.bylBaseCenterPath, '/noticeinfo/search', filters, (r) => {
            this.lists = r.data
            this.cntData = r.cntData // 总数
            this.pages = Math.ceil(r.cntData / this.filters.pageSize) // 页数
          })
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/continueEdu/news/list.vue